import { useState } from 'react';

import apiService from 'src/shared/config/apiService';

import getSuppliersEstimation from '../api/getSuppliersEstimation';

export default function useSuppliersNumber() {
  const [loading, setLoading] = useState(false);
  const [numOfSuppliers, setNumOfSuppliers] = useState<number>(0);
  const [isValidProduct, setIsValidProduct] = useState<boolean>(true);

  async function fetchSuppliersNumber(productName: string, rfqId?: number) {
    setLoading(true);

    try {
      const data = await getSuppliersEstimation({
        product_description: productName
      });

      setNumOfSuppliers(data.estimation);
      setIsValidProduct(data.valid_product ?? true);

      if (rfqId !== undefined && data.estimation !== undefined) {
        await apiService.patch(`/rfqs/${rfqId}`, {
          document: { supplier_availability: data.estimation }
        });
      }

      return;
    } catch {
      // We fake it because we don't want to show error to user at this point.
      return setNumOfSuppliers(220);
    } finally {
      setLoading(false);
    }
  }

  return {
    fetchSuppliersNumber,
    numOfSuppliers,
    isValidProduct,
    loading
  };
}
